import { Image, Tag } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import Container from "../../General/Container/Container";
import { PushpinFilled } from "@ant-design/icons";
import pushpingreen from "../../../images/pushpin/pushpingreen.png"
import pushpinblue from "../../../images/pushpin/pushpinblue.png"
import pushpinorange from "../../../images/pushpin/pushpinorange.png"

const PersonasPinItem = ({
    title = "Title",
    list = [],
    classColor,
    forPrint
}) => {
    const dispatch = useDispatch()
    const getImage = () => {
        switch (classColor.trim()) {
            case "green": return pushpingreen
            case "blue": return pushpinblue
            default: return pushpinorange
        }
    }
    return <Container className="personas-pushpin-item dcol">
        <span className={`personas-title${classColor}`}>{title}</span>
        {list.map((item, idx) => {
            return <Tag
                icon={<Image src={getImage()} preview={false} style={{ height: "4mm" }} />}
                key={idx}
                className={`personas-pushpin-text${classColor} gap-5p`}
            >
                {item}
            </Tag>
        })}
    </Container>
}

export default PersonasPinItem